import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiInfo, FiHelpCircle } from "react-icons/fi";

export default function LogisticRiderViewOrderStatusInGroup() {
  const navigate = useNavigate();
  // Backend-ready data structure
  const orders = [
    {
      id: "123459",
      paymentType: "Payment on Delivery",
      buyerLocation: "Abraka",
      pickupLocation: "Warri",
      customerMasked: "B*******r",
      status: "Preparing to Pickup",
      timeLeft: "03:59:01",
      image: "https://placehold.co/100x120/87CEEB/ffffff?text=Products",
    },
    {
      id: "123460",
      paymentType: "Paid",
      buyerLocation: "Asaba",
      pickupLocation: "Benin",
      customerMasked: "A*******e",
      status: "Preparing to Pickup",
      timeLeft: "02:20:10",
      image: "https://placehold.co/100x120/87CEEB/ffffff?text=Products",
    },
  ];

  const deliveryCost = 5000;
  const pickupBase = "Warri Warehouse";

  return (
    <div className="min-h-screen bg-[#F1F3F2] flex flex-col max-w-md mx-auto relative">

      {/* Header */}
      <div className="bg-white px-5 py-4 flex items-center justify-center relative border-b border-gray-100">
        <button className="absolute left-5" type="button" onClick={() => navigate(-1)}>
          <FiArrowLeft size={24} />
        </button>
        <h1 className="text-xl font-bold text-black">Product Group ID</h1>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#F1F3F2] px-4 py-4 overflow-y-auto pb-8">

        {/* Timer Alert */}
        <div className="mb-4">
          <p className="text-[#19C463] text-sm font-bold mb-2">
            Time left to pickup product: {orders[0].timeLeft}
          </p>
          <div className="flex items-start gap-2">
            <FiInfo size={16} color="#19C463" className="mt-0.5" />
            <p className="text-black text-xs">
              Product will be removed from deliveries when time is up.
            </p>
          </div>
        </div>

        {/* Product Cards */}
        {orders.map((order) => (
          <div key={order.id} className="mb-3">

            <div className="bg-white rounded-lg p-3 flex gap-3 shadow-sm">
              <img
                loading="lazy"
                src={order.image}
                alt="Product"
                className="w-24 h-28 rounded-lg object-cover"
              />

              <div className="flex-1 flex flex-col justify-between py-1 text-left">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <p className="text-sm font-bold text-black mb-0.5">
                      Product ID: {order.id}
                    </p>
                    <p className="text-sm text-black mb-0.5">
                      {order.paymentType}
                    </p>
                    <p className="text-sm text-black mb-0.5">
                      Buyer: {order.buyerLocation}
                    </p>
                    <p className="text-sm text-black mb-0.5">
                      Pickup: {order.pickupLocation}
                    </p>
                    <p className="text-sm text-black mb-0.5">
                      {order.customerMasked} (number will show when delivering)
                    </p>
                  </div>

                  <FiHelpCircle size={20} color="#19C463" className="ml-2 mt-1" />
                </div>

                <p className="text-sm font-bold text-black mt-2">
                  Available for Pickup
                </p>
              </div>
            </div>

            {/* Status */}
            <div className="bg-[#19C463] bg-opacity-40 rounded-md py-2 mt-2">
              <p className="text-white text-sm font-bold text-center">
                {order.status}
              </p>
            </div>

          </div>
        ))}

        {/* Bottom Info */}
        <div className="bg-white rounded-lg p-3 mb-2 mt-4">
          <p className="text-base font-bold text-black">
            Delivery Cost: {deliveryCost.toLocaleString()}
          </p>
        </div>

        <div className="bg-white rounded-lg p-3 mb-4">
          <p className="text-base font-bold text-black">
            Pickup from - {pickupBase}
          </p>
        </div>

      </div>
    </div>
  );
}
